var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadbutton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 17.5L8.25 12.5L9.65 11.05L12.25 13.65V5.5H14.25V13.65L16.85 11.05L18.25 12.5L13.25 17.5ZM7.25 21.5C6.7 21.5 6.22917 21.3042 5.8375 20.9125C5.44583 20.5208 5.25 20.05 5.25 19.5V16.5H7.25V19.5H19.25V16.5H21.25V19.5C21.25 20.05 21.0542 20.5208 20.6625 20.9125C20.2708 21.3042 19.8 21.5 19.25 21.5H7.25Z",
    fill: "#258900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadbutton);
export default __webpack_public_path__ + "static/media/download button.1286c25eec7a79271c98a02095f40bad.svg";
export { ForwardRef as ReactComponent };